module.exports = __webpack_public_path__ + "static/media/pro_plus.09ec7c86.png";